import { ApiError } from './api-utils';

export enum ErrorCode {
  HE_INSTRUCTOR_CART_EMPTY = 20025,
  HE_INSTRUCTOR_CART_RESTRICTION_BOARDS_BEYOND = 20022,
  HE_INSTRUCTOR_CART_RESTRICTION_CLINICAL_REASONING = 20024,
  HE_INSTRUCTOR_CART_RESTRICTION_FIRST_AID_FORWARD = 20023,
  HE_INSTRUCTOR_CART_RESTRICTION_K12 = 20019,
  HE_INSTRUCTOR_CART_RESTRICTION_MHP = 20020,
  HE_INSTRUCTOR_CART_RESTRICTION_SHARPEN = 20021,
  MHP_MIXED_CART_ERROR_CODE = 25000,
  MIXED_OC_RMS_PRODUCT = 23005,
  PRODUCT_ALREADY_IN_CART = 1005,
  HE_INSTRUCTOR_GUEST_PRODUCTS_REMOVED = 'generic_error_code',
}

/**
 * Returns the error code inside the api error response
 *
 * @param apiError
 */
export function getApiErrorCode(apiError: ApiError): ErrorCode | undefined {
  return apiError?.response?.code;
}
